import type { AxiosInstance } from "axios";
import { Result } from "services/Result";
import { ILocationFinderProvider } from "interfaces/providers/ILocationFinderProvider";
import { ILocationFinderResponse } from "interfaces/locationfinder/ILocationFinderResponse";
// export interface ILocationFinderResponse {
//   items: Array<IItem>;
//   clientIpAddress: string;
//   requestDateTime: string;
// }

// export interface IItem {
//   venueName: string;
//   fieldName: string;
//   systemId: string;
//   systemName: string;
//   networkName: string;
//   networkIpAddress: string;
//   networkAddressFamily: string;

//   // systemConfigurationResponse: ISystemConfiguration;
//   // publicNetworkInformation: IPublicNetworkInformation;
//   // networkInterfacesResponse: INetworkInterface[];
// }

export class LocationFinderApiService implements ILocationFinderProvider {
  getLocations = async (
    apiInstance: AxiosInstance
  ): Promise<ILocationFinderResponse> => {
    let response = await apiInstance.get<Result<ILocationFinderResponse>>(
      "api/v1/LocationFinder"
    );

    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error("Failed to fetch locations: " + response.status);
  };

  getIp = async (apiInstance: AxiosInstance): Promise<any> => {
    let response = await apiInstance.get<Result<string>>(
      "api/v1/LocationFinder/ip"
    );

    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error("Failed to fetch ip: " + response.status);
  };
}
